/**
 * useIhs — KPI 9 IHS Volume + IHS Ratio (In-House Stock Samsung)
 * GET /api/v1/market/kpis/ihs
 * spec_kpis.md §11
 */
import { useQuery } from '@tanstack/react-query';
import { fetchKpi } from '../../lib/api';
import type { KpiApiResponse, IhsData, IhsQueryParams } from '../../types/marche.types';

export function useIhs(
  params?: IhsQueryParams,
  options?: { enabled?: boolean; includeRef4w?: boolean; includeRefW1?: boolean; includeRefSwly?: boolean },
) {
  const includeRef4w   = options?.includeRef4w   ?? false;
  const includeRefW1   = options?.includeRefW1   ?? false;
  const includeRefSwly = options?.includeRefSwly ?? false;
  const effectiveParams: IhsQueryParams | undefined =
    includeRef4w || includeRefW1 || includeRefSwly
      ? {
          ...params,
          ...(includeRef4w   ? { include_ref4w:    true } : {}),
          ...(includeRefW1   ? { include_ref_w1:   true } : {}),
          ...(includeRefSwly ? { include_ref_swly: true } : {}),
        }
      : params;
  return useQuery<KpiApiResponse<IhsData>>({
    queryKey: ['market', 'ihs', params, { includeRef4w, includeRefW1, includeRefSwly }],
    queryFn: () => fetchKpi<IhsData>('ihs', effectiveParams),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
